// src/layouts/DashboardLayout.js
import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Sidebar isOpen={isSidebarOpen} />
      <div style={{ flex: 1, marginLeft: isSidebarOpen ? "250px" : "70px", transition: "margin-left 0.3s ease" }}>
        <Header toggleSidebar={toggleSidebar} />
        <div style={{ padding: "20px", overflowY: "auto", height: "calc(100vh - 60px)", backgroundColor: "#f8f9fc" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
